import { render, staticRenderFns } from "./tabellaSpark.vue?vue&type=template&id=5a5bfeca&scoped=true"
import script from "./tabellaSpark.vue?vue&type=script&lang=js"
export * from "./tabellaSpark.vue?vue&type=script&lang=js"
import style0 from "./tabellaSpark.vue?vue&type=style&index=0&id=5a5bfeca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bfeca",
  null
  
)

export default component.exports